<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let to = '';
export let style = '';
</script>

<a on:click|preventDefault = { () => { history.pushState({}, "", to); window.scrollTo(0, 0); } } href={to} style={style}>
<slot></slot>
</a>
<style>
</style>
